export const navigation = [
    {
        label: "Мужчины",
        role: "all",
        to: "/gender/men",
    },
    {
        label: "Женщины",
        role: "all",
        to: "/gender/women",
    },
    {
        label: "Соревнования",
        role: "all",
        to: "/tournaments",
    },
    {
        label: "Справочники",
        role: "all",
        items: [
            {
                label: "Льготы",
                role: "all",
                to: "/facilities",
            },
            {
                label: "Населенные пункты",
                role: "all",
                to: "/settlements/settlements_main",
            },
            {
                label: "Субъекты РФ",
                role: "all",
                to: "/subjects",
            },
            {
                label: "Федеральные округа",
                role: "all",
                to: "/federal_district",
            },
            {
                label: "Страны",
                role: "all",
                to: "/countries",
            },
            {
                label: "Судьи",
                role: "all",
                to: "/judges/judges_main",
            },
        ],
    },
    {
        label: "Сервис",
        role: "all",
        items: [
            {
                label: "Поиск дублей игроков",
                role: "all",
                to: "/service/player-duplicates",
            },
            {
                label: "Слияния игроков",
                role: "all",
                to: "/service/player-merges",
            },
            {
                label: "Пересчёты рейтинга",
                role: "all",
                to: "/service/recalculations",
            },
        ],
    },
    {
        label: "Параметры",
        role: "all",
        to: "/options/payment",
    },
];
